// The rings overlap, so the middle disc's 0.6 composes with the outer 0.2 to the 0.68 tint of the original artwork.
export function TimerAssistant({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="60"
        height="60"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="60" cy="60" r="60" fill="var(--clr-general-primary)" fillOpacity="0.2" />
        <circle cx="60" cy="60" r="44" fill="var(--clr-general-primary)" fillOpacity="0.6" />
        <circle cx="60" cy="60" r="30" fill="var(--clr-general-primary)" />
        <rect x="42" y="42" width="15.25" height="36" rx="3" fill="var(--clr-white)" />
        <rect x="62.75" y="42" width="15.25" height="36" rx="3" fill="var(--clr-white)" />
      </svg>
    </span>
  );
}
